import { render, staticRenderFns } from "./import_template_rule.vue?vue&type=template&id=0063815e&scoped=true&"
import script from "./import_template_rule.vue?vue&type=script&lang=js&"
export * from "./import_template_rule.vue?vue&type=script&lang=js&"
import style0 from "./import_template_rule.vue?vue&type=style&index=0&id=0063815e&scoped=true&lang=css&"
import style1 from "./import_template_rule.vue?vue&type=style&index=1&id=0063815e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0063815e",
  null
  
)

export default component.exports